import { ApiHelper } from '../helpers/api.helper';
import { IAccessToken } from '../types/security.type';
import { IStatusResponse } from '../types/status-response.type';
import { IEmailForm, IPhoneForm, IValidationCodeForm } from '../views/SignIn/types';
import { IRegistrationForm } from '../views/SignUp/types';

const url = 'security';

export const sendRegistration = async (params: IRegistrationForm): Promise<IStatusResponse> => {
  const formData = new FormData();

  Object.keys(params).forEach((key) => {
    formData.append(key, (params as any)[key]);
  });

  const response = await fetch(ApiHelper.makeUrl(`${url}/registration`), {
    method: 'POST',
    body: formData,
    ...ApiHelper.makeOptions(false),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data;
};

export const sendVerificationCodeViaPhone = async (
  params: IPhoneForm,
): Promise<IStatusResponse> => {
  const response = await fetch(ApiHelper.makeUrl(`${url}/auth/phone`), {
    method: 'POST',
    body: JSON.stringify(params),
    ...ApiHelper.makeOptions(),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data;
};

export const sendVerificationCodeViaEmail = async (
  params: IEmailForm,
): Promise<IStatusResponse> => {
  const response = await fetch(ApiHelper.makeUrl(`${url}/auth/email`), {
    method: 'POST',
    body: JSON.stringify(params),
    ...ApiHelper.makeOptions(),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data;
};

export const validateVerificationCode = async (
  params: IValidationCodeForm,
): Promise<IAccessToken> => {
  const response = await fetch(ApiHelper.makeUrl(`${url}/auth/verification`), {
    method: 'POST',
    body: JSON.stringify(params),
    ...ApiHelper.makeOptions(),
  });

  const data = await response.json();

  if (!response.ok) {
    ApiHelper.handleError(data);
  }

  return data;
};
